export default "__VITE_ASSET__BAdTPnBV__"